import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { IQueryableRouteComponentProps } from 'easit--routing';
import { ApplicationStore, ApplicationStoreKey } from '../../liveStores';
import { SimpleBarWrapper as SimpleBar, CalendarList } from 'desktop--design-library';
import { ProgressContent } from 'common--design-library';
import { pushToEventDetail } from '../../liveRouting';
import { translationForMts } from 'easit--localization';
import { Instance } from 'mobx-state-tree';

export interface ISearchContainerProps {
    searchText?: string;
}

export interface ISearchContainerProps extends IQueryableRouteComponentProps<ISearchContainerProps, {}> {
    applicationStore?: Instance<typeof ApplicationStore>;
}

@inject(ApplicationStoreKey)
@observer
export class SearchContainer extends React.Component<ISearchContainerProps> {
    constructor(props: ISearchContainerProps) {
        super(props);
    }

    get searchStore() {
        return this.props.applicationStore.search;
    }

    componentWillMount() {
        this.props.applicationStore.setCanShowLeftColumn(true);
        this.searchStore.setSearchText(this.props.match.params.searchText);
        this.searchStore.loadAsync();
    }

    componentWillReceiveProps() {
        if (this.searchStore.textChanged) {
            this.searchStore.loadAsync();
        }
    }

    render() {
        return <SimpleBar className="h-100" forceVisible={true} scrollToTop>
            <h1 className="p-1">{translationForMts().search_searchEventTitle}</h1>
            <ProgressContent state={this.searchStore.state}>
                <CalendarList items={[...this.searchStore.events]}
                    canShowLinkForLiveOnly={true}
                    onGoToDetail={(eventId: number, goToPrematch: boolean) => { pushToEventDetail(eventId, false, false, goToPrematch) }}
                />
            </ProgressContent>
        </SimpleBar>
    }
}